import { PageTitle } from '_metronic/layout/core'

import ProductionLineSelection from 'Presentation/Components/ProductLineSelection'
import LoadingProductLineSelection from 'Presentation/Components/Loading/LoadingProductLineSelection'

import useViewModel from './ViewModel'
import clsx from 'clsx'

//////////
// View //
//////////

const ProductionGroupView: React.FC = () => {
	const {
		isLoadingProductLine,
		isLoadingProductCategory,
		productLineData,
		productCategoryData,
		selectProductLine,
		selectProductCategory,
		productCategoryRef,
		currentActiveProductLine,
		currentActiveProductCategory,
		changeProductLineActive,
		changeProductCategoryActive,
	} = useViewModel()

	return (
		<ViewPageTitle>
			<div className="card border border-kumopack-grey-200" style={{ minHeight: '70vh' }}>
				<div className="card-body" style={{ minHeight: '70vh' }}>
					<div
						className="row gy-5 align-items-center justify-content-center"
						style={{ minHeight: '70vh' }}>
						<div className="col-12">
							<div
								className={clsx({
									'd-none': !isLoadingProductLine,
									'd-block': isLoadingProductLine,
								})}>
								<LoadingProductLineSelection title="Step 1 - เลือก Product Line" />
							</div>

							<div
								className={clsx({
									'd-none': isLoadingProductLine,
									'd-block': !isLoadingProductLine,
								})}>
								<ProductionLineSelection
									title="Step 1 - เลือก Product Line"
									products={productLineData}
									onClickCard={id =>
										selectProductLine(id, productLineData.find(x => x.id === id)?.hasChild ?? false)
									}
									customActive={currentActiveProductLine}
									setCustomActive={changeProductLineActive}
								/>
							</div>

							<div
								className={clsx({
									'd-none': !isLoadingProductCategory,
									'd-block': isLoadingProductCategory,
								})}>
								<LoadingProductLineSelection title="Step 1.1 - เลือก Product Category" />
							</div>

							<div
								id="product-category"
								ref={productCategoryRef}
								className={clsx({
									'd-none': isLoadingProductCategory || productCategoryData.length === 0,
									'd-block': !isLoadingProductCategory,
								})}>
								<ProductionLineSelection
									title="Step 1.1 - เลือก Product Category"
									products={productCategoryData}
									onClickCard={id => selectProductCategory(id)}
									customActive={currentActiveProductCategory}
									setCustomActive={changeProductCategoryActive}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'General',
						path: '/general/production',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Production',
						path: '/general/production',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Setting',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				Production Setting
			</PageTitle>

			{children}
		</>
	)
}

export default ProductionGroupView
